// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__26f51","footer":"ModalUpdate_footer__1VpeW"};